import { Box, Grid, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { getApiServicesAssistantsOptions } from "@/api/generated/@tanstack/react-query.gen";
import { Loader } from "@/components/loader";
import { AssistantCard } from "@/domain/chat/components/assistant-card";

function App() {
  const { data, isLoading, isError } = useQuery(
    getApiServicesAssistantsOptions({ query: { isPublished: true, limit: 100 } }),
  );

  const assistants = data?.items ?? [];

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="error">Failed to load assistants. Please try again later.</Typography>
      </Box>
    );
  }

  if (assistants.length === 0) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="text.secondary">No assistants available. Check back later.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Choose an Assistant
      </Typography>
      <Grid container spacing={2}>
        {assistants.map((assistant) => (
          <Grid key={assistant.id} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <AssistantCard assistant={assistant} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default App;
